import React from 'react';

const Research = () => {
    return (
        <main className="min-h-screen bg-[#050914] text-white">

            <section className="pt-36 pb-28">
                <div className="max-w-[1200px] mx-auto px-8">

                    <div className="flex items-center gap-3 text-[11px] tracking-[0.28em] text-neutral-500 mb-7">
                        <span className="w-8 h-px bg-neutral-600" />
                        RESEARCH
                    </div>

                    <h1 className="max-w-[900px] text-[48px] sm:text-[64px] lg:text-[76px] leading-[1] font-semibold tracking-[-0.045em]">
                        Building the evidence
                        <br />
                        <span className="text-neutral-500">
              behind the experience.
            </span>
                    </h1>

                    <p className="mt-8 max-w-[720px] text-[17px] leading-[1.7] text-neutral-400">
                        Our research work focuses on turning EEG signals into measurable
                        and useful cognitive-state estimates, then testing how well those
                        models generalize beyond the data used to build them.
                    </p>

                </div>
            </section>

            <section className="border-t border-white/10 py-28">
                <div className="max-w-[1200px] mx-auto px-8">

                    <div className="grid md:grid-cols-2 gap-5">

                        <article className="rounded-[28px] border border-[#8ea5ff]/20 bg-[#10162a] p-8 sm:p-10">
                            <div className="text-[10px] tracking-[0.24em] text-[#8ea5ff]">
                                CURRENT
                            </div>

                            <h2 className="mt-8 text-[28px] font-medium">
                                Evaluated ML model
                            </h2>

                            <p className="mt-5 text-[15px] leading-7 text-neutral-500">
                                Our first model-development work uses research EEG data to
                                develop and evaluate the inference pipeline.
                            </p>
                        </article>

                        <article className="rounded-[28px] border border-white/10 bg-white/[0.02] p-8 sm:p-10">
                            <div className="text-[10px] tracking-[0.24em] text-neutral-600">
                                NEXT
                            </div>

                            <h2 className="mt-8 text-[28px] font-medium">
                                Human validation
                            </h2>

                            <p className="mt-5 text-[15px] leading-7 text-neutral-500">
                                The next stage is testing with new participants and measuring
                                how well the system generalizes outside the development data.
                            </p>
                        </article>

                    </div>

                </div>
            </section>

        </main>
    );
};

export default Research;